import React, { useState, useEffect } from 'react';
import { useCMSSettings } from '../hooks/useCMSSettings';

export const CookieBanner = () => {
  const { settings } = useCMSSettings();
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user already consented
    const consented = localStorage.getItem('cookie_consent');
    if (settings?.cookie_banner_enabled === 'true' && !consented) {
      setShow(true);
    }
  }, [settings]);

  if (!show) return null;

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    setShow(false);
    // Reload to inject scripts immediately
    window.location.reload();
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'false');
    setShow(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[999] bg-black border-t border-white/10 p-4 md:p-6 flex flex-col md:flex-row items-center justify-between gap-4 glass-panel">
      <div className="text-white/80 text-sm md:text-base max-w-4xl text-left">
        {settings?.cookie_message || 'We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.'}
      </div>
      <div className="flex gap-3 whitespace-nowrap">
        <button
          onClick={handleDecline}
          className="px-4 py-2 border border-white/20 text-white rounded-md hover:bg-white/10 transition-colors"
        >
          Decline
        </button>
        <button
          onClick={handleAccept}
          className="px-4 py-2 bg-gradient-to-r from-amber-500 to-amber-700 text-white rounded-md hover:opacity-90 transition-opacity font-medium shadow-[0_0_15px_rgba(245,158,11,0.5)]"
        >
          Accept All
        </button>
      </div>
    </div>
  );
};
